import { createGlobalStyle } from "styled-components";
import "react-redux-toastr/lib/css/react-redux-toastr.min.css";

export const GlobalStyle = createGlobalStyle`
  html,
  body,
  #root {
    height: 100%;
  }

  body {
    margin: 0;
    font-family: -apple-system, BlinkMacSystemFont, sans-serif;
  }

  button,
  input,
  textarea,
  select,
  [contenteditable] {
    outline: none;
    border: none;
  }

  button {
    cursor: pointer;

    &:disabled {
      cursor: not-allowed;
    }
  }

  kbd {
    display: inline-block;
    padding: 4px 6.6px;
    border-radius: 3px;
    border: 1px solid #b4b4b4;
    font-size: 1rem;
    font-weight: 700;
    line-height: 1;
    white-space: nowrap;
    color: #333;
    background-color: #eee;
    box-shadow: 0 1px 1px rgba(0, 0, 0, .2), 0 2px 0 0 rgba(255, 255, 255, .7) inset;
  }
`;
